import script from "./KpiInvoicingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiInvoicingCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__